import { render, staticRenderFns } from "./JournalDetails.vue?vue&type=template&id=a96ab728&scoped=true&"
import script from "./JournalDetails.vue?vue&type=script&lang=js&"
export * from "./JournalDetails.vue?vue&type=script&lang=js&"
import style0 from "./JournalDetails.vue?vue&type=style&index=0&id=a96ab728&lang=less&scoped=true&"
import style1 from "./JournalDetails.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96ab728",
  null
  
)

export default component.exports